import React from "react";
import { MoreHorizontal } from "lucide-react";
import { Button } from "../../../ui/button";
import { TriggerProps } from "../types";
import { cn } from "../../../utils";

export const DefaultTrigger = React.forwardRef<HTMLButtonElement, TriggerProps>(
  (
    { triggerAriaLabel = "Open actions menu", className, ...triggerProps },
    ref,
  ) => {
    return (
      <Button
        ref={ref}
        variant="ghost"
        size="icon-sm"
        aria-label={triggerAriaLabel}
        className={cn(
          "flex items-center justify-center hover:bg-fill-table-neutral-active-lvl-2",
          className,
        )}
        {...triggerProps}
      >
        <MoreHorizontal className="size-4" />
      </Button>
    );
  },
);

DefaultTrigger.displayName = "DefaultTrigger";
